import React from 'react';
import {css, StyleSheet} from "aphrodite";
import GridStyles from "../styles/styles";
import Config from "../config/Config";
import Card from "./Card";
import MediaQuery from "../styles/MediaQuery";

const CardsArea = ({extraStyle, cards, reverse}) => {
    const styles = StyleSheet.create({
        container: {
            ...GridStyles.define("max-content", "minmax(20px, auto) minmax(auto, 1188px) minmax(20px, auto)"),
            background: `linear-gradient(180deg, ${reverse ? Config.colors.CARDS_BACKGROUND : Config.colors.HEADER_BACKGROUND} 50%, ${reverse ? Config.colors.HEADER_BACKGROUND : Config.colors.CARDS_BACKGROUND} 50%)`,
            ...MediaQuery.mobile({
                ...GridStyles.define("max-content", "minmax(20px, auto) max-content minmax(20px, auto)"),
            })
        },
        cardsWrapper: {
            columnGap: 24,
            rowGap: "minmax(5px, 24px)",
            justifyContent: "center",
            ...GridStyles.setRowCol(1, 2),
            ...GridStyles.define("1fr", "minmax(auto, 380px) minmax(auto, 380px) minmax(auto, 380px)"),
            ...MediaQuery.cards({
                ...GridStyles.define("max-content max-content max-content", "343px"),
                gridRowGap: 0,
                columnGap: 0
            })
        },
        firstCard: {
            ...GridStyles.setRowCol(1, 1),
            ...MediaQuery.cards(GridStyles.setRowCol(1, 1))
        },
        secondCard: {
            ...GridStyles.setRowCol(1, 2),
            ...MediaQuery.cards(GridStyles.setRowCol(2, 1))
        },
        thirdCard: {
            ...GridStyles.setRowCol(1, 3),
            ...MediaQuery.cards(GridStyles.setRowCol(3, 1))
        },
    });

    return (
        <div className={css(styles.container, extraStyle)}>
            <div className={css(styles.cardsWrapper)}>
                <Card extraStyle={styles.firstCard} card={cards[0]}/>
                <Card extraStyle={styles.secondCard} card={cards[1]}/>
                <Card extraStyle={styles.thirdCard} card={cards[2]}/>
            </div>
        </div>
    );
};

export default CardsArea;
